"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotificationDot = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const NotificationDot = /*#__PURE__*/_styledComponents.default.div.attrs(({
  dataTest
}) => ({
  "data-test": dataTest
})).withConfig({
  displayName: "NotificationDot",
  componentId: "sc-f9jhck-0"
})(["width:10px;height:10px;background-color:", ";border-radius:50%;position:absolute;top:-2px;right:-2px;z-index:10;"], ({
  theme
}) => theme.orbit.borderColorButtonCriticalBordered);
exports.NotificationDot = NotificationDot;
var _default = NotificationDot;
exports.default = _default;